import Vue from 'vue';
import {Howl, Howler} from 'howler';

export default {
    data() {
        return {
            soundId: {},
        }
    },
    computed: {
        audios: {
            get() {
                return this.$gameData.audios
            },
            set(val) {
                this.$set(this.$gameData, 'audios', val)
            }
        },
        bgms: {
            get() {
                return this.$gameData.bgms
            },
            set(val) {
                this.$set(this.$gameData, 'bgms', val)
            }
        },
        muted: {
            get() {
                return this.$store.getters.isMuted
            },
            set(val) {
                this.$store.commit('setMute', val)
            }
        },
    },

    mounted() {
    },

    watch: {
    },
    methods: {
        async $loadAudio() {
            const response = await this.axios.get('/api/audio')
            response.data.result.forEach(item => {
                if (item.type === 'audio') {
                    if (this.audios[item.label]) return

                    // this.volumes[item.label] = item.volume

                    this.audios[item.label] = new Howl({
                        src: [item.url],
                        autoplay: false,
                        loop: item.id === 5,
                    })
                } else if (item.type === 'bgm') {

                    if (this.bgms[item.label]) return

                    // this.volumes[item.label] = item.volume

                    this.bgms[item.label] = new Howl({
                        src: [item.url],
                        autoplay: false,
                        loop: true,
                        mute: this.muted,
                    })
                }
            })

        },

        $playAudio(label) {
            label = String(label)

            if (!Object.keys(this.audios).length) {
                // console.log('audios is not loaded')
                setTimeout(_ => {
                    this.$playAudio(label)
                }, 1000)
            } else {
                let audio = this.audios[label]
                if (!audio) {
                    audio = this.bgms[label]

                    if (audio.playing()) return

                    Object.keys(this.bgms).forEach(id=> {
                        const bgm = this.bgms[id]
                        if (bgm.playing()) {
                            bgm.stop()
                            // audio.fade(1, 0, 1000, this.soundId[id])
                            // setTimeout(_ => {
                            //     audio.stop()
                            //     delete this.soundId[id]
                            // }, 1000)
                        }
                    })

                }

                // const volume = this.$userData.setting.volume
                // audio.volume(this.volumes[label] * (volume / 100))

                // this.soundId[label] = audio.play()
                audio.play()
            }
        },

        $stopAudio(label) {
            this.audios[String(label)].stop()
        },

        $stopBgms() {
            Object.keys(this.bgms).forEach(label => {
                this.bgms[label].stop()
            })
        },

        $toggleMute() {
            this.muted = !this.muted
            Object.keys(this.audios).forEach(label => {
                this.audios[label].mute(this.muted)
            })
            Object.keys(this.bgms).forEach(label => {
                this.bgms[label].mute(this.muted)
            })
        },

        $stopAll() {
            Object.keys(this.audios).forEach(label => {
                this.audios[label].stop()
            })
            Object.keys(this.bgms).forEach(label => {
                this.bgms[label].stop()
            })
        },
    }

};
